import { headers } from './requestConfig';
import { releaseRequest, autoFormation, teamCaptain } from '../service/links';

export const sendReleaseRequest = async (playerID) => {
  const response = await fetch(releaseRequest, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      playerID,
    }),
  });
  return response;
};

export const setCaptain = async (playerID) => {
  const response = await fetch(teamCaptain, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      playerID,
    }),
  });
  return response;
};

export const sendAutoFormationRequest = async (strategy, extra = {}) => {
  const body = { strategy, ...extra };
  Object.keys(body).forEach((key) => {
    if (body[key] === undefined) delete body[key];
  });
  const response = await fetch(autoFormation, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return response;
};
